import Vue from "vue";
import VueRouter from "vue-router";
import layout from "@/layout/index.vue";
import request from "@/utils/request";
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: layout,
        redirect: "/home",
        children: [
            {
                path: "/:back_s/index",
                name: "index",
                meta: { title: "首页" },
                component: () => import("@/views/Index/index.vue"),
            },
            {
                path: "/:back_s/newsList",
                name: "newsList",
                meta: { title: "新闻列表" },
                component: () => import("@/views/NewsList/index.vue"),
            },
            {
                path: "/:back_s/applyProcess",
                name: "applyProcess",
                meta: { title: "报名流程" },
                component: () => import("@/views/ApplyProcess/index.vue"),
            },
            {
                path: "/:back_s/schedule",
                name: "schedule",
                meta: { title: "报名表" },
                component: () => import("@/views/Schedule/index.vue"),
            },
            {
                path: "/:back_s/apply",
                name: "apply",
                meta: { title: "报名" },
                component: () => import("@/views/Apply/index.vue"),
            },
            {
                path: "/:back_s/register",
                name: "register",
                meta: { title: "注册" },
                component: () => import("@/views/Register/index.vue"),
            },
            {
                path: "/:back_s/FindPwd",
                name: "findPwd",
                meta: { title: "找回密码" },
                component: () => import("@/views/FindPwd/index.vue"),
            },
            {
                path: "/:back_s/newsDetail",
                name: "newsDetail",
                meta: { title: "新闻详情" },
                component: () => import("@/views/newsDetail/index.vue"),
            },
            {
                path: "/:back_s/applyForm",
                name: "applyForm",
                meta: { title: "报名表" },
                component: () => import("@/views/ApplyForm/index.vue"),
            },
            {
                path: "/:back_s/interviewTicket",
                name: "interviewTicket",
                meta: { title: "面试准考证" },
                component: () => import("@/views/InterviewTicket/index.vue"),
            },
            {
                path: "/:back_s/admissionTicket",
                name: "admissionTicket",
                meta: { title: "笔试准考证" },
                component: () => import("@/views/AdmissionTicket/index.vue"),
            },
            {
                path: "/:back_s/achievement",
                name: "achievement",
                meta: { title: "我的笔试成绩" },
                component: () => import("@/views/Achievement/index.vue"),
            },
            {
                path: "/:back_s/achievementM",
                name: "achievementM",
                meta: { title: "我的面试成绩" },
                component: () => import("@/views/AchievementM/index.vue"),
            },
            {
                path: "/:back_s/guideList",
                name: "guideList",
                meta: { title: "报考指南列表" },
                component: () => import("@/views/GuideList/index.vue"),
            },
            {
                path: "/:back_s/guideDetail",
                name: "guideDetail",
                meta: { title: "报考指南详情" },
                component: () => import("@/views/GuideDetail/index.vue"),
            },
            {
                path: "/:back_s/agreement",
                name: "agreement",
                meta: { title: "协议" },
                component: () => import("@/views/Agreement/index.vue"),
            },
        ],
    },
];

const router = new VueRouter({
    routes,
});
router.beforeEach((to, from, next) => {
    if (to.path == "/home") {
        next();
    } else {
        request({
            url: "/api/platform/back_custom/" + to.params.back_s,
            method: "get",
        }).then((res) => {
            if (res.status == 200) {
                localStorage.setItem("custom_id", res.message);
                localStorage.setItem("back_s", res.message);
                next();
            }
        });
    }
});

export default router;
